module.exports = __webpack_public_path__ + "img/corporate-businessmen-working-tablet-office.747227eb.png";